import type { CityConfig } from "@/pages/city-template/types";

export const hillsboroConfig: CityConfig = {
  vitalRecordsIcon: "ri-file-text-line",
  vitalRecordsLinks: [
    { icon: "ri-file-text-line", label: "Oregon Vital Records (Birth, Death, Marriage)", desc: "Request certified birth, death, and marriage certificates from Oregon Vital Records.", url: "https://www.oregon.gov/oha/PH/BirthDeathCertificates/Pages/index.aspx" },
    { icon: "ri-government-line", label: "Washington County Clerk Vital Records", desc: "Obtain vital records through the Washington County Clerk's office.", url: "https://www.washingtoncountyor.gov/CountyClerk" },
    { icon: "ri-global-line", label: "VitalChek — Order Vital Records Online", desc: "Official online ordering partner of Oregon Vital Records for certified certificates.", url: "https://www.vitalchek.com/" },
  ],
  city: "Hillsboro",
  state: "Oregon",
  stateAbbr: "OR",
  slug: "hillsboro",
  route: "/cities/hillsboro",
  title: "Emergency Passport Hillsboro, OR | Fast Passport Renewal & Expedited Services",
  metaDescription: "Emergency passport and expedited passport services in Hillsboro, OR — as fast as 24 hours. Fast passport renewal, same-day help, and child passport expediting for Silicon Forest tech workers and Washington County travelers. A+ BBB rated, registered State Dept. courier.",
  h1: "Emergency & Expedited Passport Services in Hillsboro, Oregon",
  heroSubtitle: "Passport expired before your business trip to Asia? Flying out of PDX in days? Fast Passport Center helps Hillsboro travelers get their passports fast — as fast as 24 hours. A+ BBB rated. No office visit required for most services.",
  heroImageUrl: "https://readdy.ai/api/search-image?query=Hillsboro%20Oregon%20aerial%20view%20of%20Silicon%20Forest%20tech%20campus%20area%2C%20suburban%20Washington%20County%20landscape%20with%20modern%20office%20buildings%2C%20green%20parks%20and%20residential%20neighborhoods%2C%20distant%20Cascade%20Mountains%20on%20horizon%2C%20soft%20morning%20light%20with%20clear%20Pacific%20Northwest%20sky%2C%20photorealistic%20landscape%20photography%2C%20no%20readable%20text%20or%20signs&width=1800&height=700&seq=hillsboro-hero-01&orientation=landscape",
  heroImageAlt: "Hillsboro Oregon aerial view of Silicon Forest and Washington County suburbs",
  geoPosition: "45.5229;-122.9898",
  geoPlacename: "Hillsboro, Oregon",
  lastModified: "2026-06-14",
  regionalAgency: {
    name: "Seattle Passport Agency",
    address: "915 2nd Ave Suite 500, Seattle WA 98174",
    distance: "About 175 miles north — 3 hours by car",
  },
  nearbyCitiesZips: [
    { name: "Hillsboro", zips: "97122–97124" },
    { name: "Beaverton", zips: "97002–97078" },
    { name: "Forest Grove", zips: "97116" },
    { name: "Cornelius", zips: "97113" },
    { name: "Tigard", zips: "97223, 97224" },
    { name: "Tualatin", zips: "97062" },
    { name: "Sherwood", zips: "97140" },
    { name: "Newberg", zips: "97132" },
    { name: "Wilsonville", zips: "97070" },
    { name: "Portland", zips: "97201–97299" },
    { name: "Aloha", zips: "97003, 97006, 97007, 97008" },
    { name: "North Plains", zips: "97133" },
    { name: "Banks", zips: "97106" },
    { name: "Gaston", zips: "97119" },
    { name: "King City", zips: "97224" },
    { name: "Lake Oswego", zips: "97034–97035" },
  ],
  benefits: [
    { icon: "ri-computer-line", title: "Start 100% Online", desc: "No office visit required to begin. Complete your order from home or work in Hillsboro in minutes — perfect for busy tech professionals." },
    { icon: "ri-truck-line", title: "Ship Overnight from Hillsboro", desc: "FedEx and UPS locations throughout Hillsboro and Beaverton offer overnight shipping to our processing center." },
    { icon: "ri-shield-check-line", title: "Expert Document Review", desc: "Every application is reviewed by our team before submission to reduce errors and delays — critical for last-minute business travel." },
    { icon: "ri-calendar-check-line", title: "Reserved Agency Access", desc: "We hold reserved submission slots at the nearest regional passport agency — no public appointment hunting needed." },
  ],
  testimonials: [
    {
      name: "Jennifer H.",
      location: "Hillsboro, OR",
      rating: 5,
      text: "Business trip to Singapore announced with one week notice. Fast Passport Center got my passport renewed in 4 business days. I dropped off at the UPS on Cornell Road. Seamless experience.",
      service: "Passport Renewal",
    },
    {
      name: "Raj P.",
      location: "Beaverton, OR",
      rating: 5,
      text: "Conference in Berlin in 10 days and my passport was in my old name after divorce. Fast Passport Center handled the name change and expedited renewal in 6 days. Incredible support.",
      service: "Name Change Passport",
    },
    {
      name: "Linda K.",
      location: "Tualatin, OR",
      rating: 5,
      text: "My son needed a passport for a school trip to Japan. The child passport process felt overwhelming but Fast Passport Center broke it down step by step. Had it in 9 days.",
      service: "Child Passport",
    },
  ],
  facilities: [
    {
      id: "hillsboro-post",
      name: "Hillsboro Main Post Office",
      type: "USPS Passport Acceptance",
      address: "1185 NE 3rd Ave",
      city: "Hillsboro",
      state: "OR",
      zip: "97124",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4:30pm, Sat 9am–12pm",
      distance: "Downtown Hillsboro",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Primary passport acceptance location in Hillsboro. Appointment required — book online in advance. Photo services may be available.",
      icon: "ri-mail-line",
    },
    {
      id: "hillsboro-tanasbourne",
      name: "Hillsboro Tanasbourne Station",
      type: "USPS Passport Acceptance",
      address: "12770 SW Walker Rd",
      city: "Beaverton",
      state: "OR",
      zip: "97005",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4:30pm",
      distance: "Tanasbourne area — about 4 miles east",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Washington County option near Hillsboro/Beaverton border. Confirm appointment and photo availability.",
      icon: "ri-mail-line",
    },
    {
      id: "beaverton-post",
      name: "Beaverton Post Office",
      type: "USPS Passport Acceptance",
      address: "4265 SW 106th Ave",
      city: "Beaverton",
      state: "OR",
      zip: "97005",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4:30pm",
      distance: "Beaverton — about 8 miles east",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Beaverton option for eastern Hillsboro metro residents.",
      icon: "ri-mail-line",
    },
    {
      id: "forest-grove-post",
      name: "Forest Grove Post Office",
      type: "USPS Passport Acceptance",
      address: "2119 21st Ave",
      city: "Forest Grove",
      state: "OR",
      zip: "97116",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4pm",
      distance: "Forest Grove — about 12 miles west",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "Western Washington County option for Forest Grove and Cornelius residents.",
      icon: "ri-mail-line",
    },
    {
      id: "tualatin-post",
      name: "Tualatin Post Office",
      type: "USPS Passport Acceptance",
      address: "19500 SW Boones Ferry Rd",
      city: "Tualatin",
      state: "OR",
      zip: "97062",
      phone: "800-275-8777",
      hours: "Mon–Fri 9am–4pm",
      distance: "Tualatin — about 10 miles southeast",
      website: "https://tools.usps.com/find-location.htm",
      websiteLabel: "Schedule Appointment",
      notes: "South metro option for Tualatin and Sherwood area residents.",
      icon: "ri-mail-line",
    },
    {
      id: "washington-county",
      name: "Washington County Clerk",
      type: "County Passport Acceptance",
      address: "155 N 1st Ave, Suite 130",
      city: "Hillsboro",
      state: "OR",
      zip: "97124",
      phone: "503-846-8791",
      hours: "Mon–Fri 8am–5pm (by appointment)",
      distance: "Downtown Hillsboro — Courthouse",
      website: "https://www.washingtoncountyor.gov/Recorder",
      websiteLabel: "Washington County Clerk",
      notes: "Washington County clerk passport acceptance. Appointment required — may offer faster scheduling than USPS. Call to confirm passport services.",
      icon: "ri-government-line",
    },
  ],
  faqs: [
    {
      q: "Can I get an emergency passport in Hillsboro before international travel?",
      a: "Yes. Through Fast Passport Center, Hillsboro travelers can get an expedited passport in as little as 2–9 business days, and emergency processing is available in as fast as 24 hours depending on your eligibility and travel documentation. Start your order online today — ideal for Silicon Forest business travel and Washington County vacation plans.",
    },
    {
      q: "How fast can I renew my passport in Hillsboro?",
      a: "Fast passport renewal in Hillsboro is available through Fast Passport Center in as little as 3 business days with our expedited service, or 3–5 weeks with our standard expedited option. Renewal applications are eligible if your current passport was issued at age 16 or older and within the last 15 years. No office visit required for most renewals.",
    },
    {
      q: "What if my passport expires before my business trip?",
      a: "If your passport expires before a business trip, don't wait. Many countries require your passport to be valid for at least 6 months beyond your travel dates. Fast Passport Center can expedite your renewal so you don't miss your flight or conference. The sooner you start, the more options you have.",
    },
    {
      q: "Can I get a same-day passport appointment near Hillsboro?",
      a: "Same-day passport appointments at the regional passport agency in Seattle are only available for documented life-or-death emergencies and are not guaranteed. For most urgent passport situations near Hillsboro, Fast Passport Center is the faster and more predictable option — no Seattle drive required.",
    },
    {
      q: "Can I expedite a child passport in Hillsboro?",
      a: "Yes. Child passport expediting in Hillsboro is possible through Fast Passport Center, but child passports (for minors 15 and under) do require an in-person acceptance step with parental consent. We provide a clear checklist and instructions. Once the acceptance step is complete, we handle the expedited processing.",
    },
    {
      q: "What should I do if I lost my passport before a trip?",
      a: "If your passport is lost or stolen before an upcoming trip, act immediately. You will need to complete Form DS-64 to report it lost or stolen and apply for a replacement. Fast Passport Center guides you through this process and can expedite your replacement passport. Don't delay — lost passport replacements take extra steps.",
    },
    {
      q: "Does Hillsboro have a passport agency?",
      a: "Hillsboro, Oregon does not have a regional passport agency. The closest regional agencies are the Seattle Passport Agency in Washington (about 175 miles north) and the San Francisco Passport Agency in California (about 640 miles south). Both require appointments and proof of travel within 14 days. Fast Passport Center is the faster and more convenient solution for most Hillsboro residents.",
    },
    {
      q: "How long does a standard passport take in Hillsboro?",
      a: "If you apply through a standard post office acceptance facility in Hillsboro, processing times run 6–13 weeks — sometimes longer during peak travel season. If your travel is sooner than that, you need expedited processing. Fast Passport Center offers Hillsboro travelers processing as fast as 24 hours.",
    },
    {
      q: "Can I get a passport renewal near me in Hillsboro without visiting an office?",
      a: "Yes. Most Hillsboro-area adults who are renewing a passport can do so entirely by mail — no in-person visit required. Start your order online with Fast Passport Center, complete your documents at home, and ship them overnight from any FedEx or UPS location in Hillsboro or Beaverton.",
    },
    {
      q: "What airports do Hillsboro travelers typically fly from?",
      a: "Hillsboro travelers typically use Portland International Airport (PDX) — about 25 miles east — for all domestic and international departures. Hillsboro Airport (HIO) is a general aviation airport only. If your passport isn't in hand, don't book international travel. Fast Passport Center can help you meet your deadline.",
    },
  ],
  photoLocations: [
    { name: "Walgreens — Hillsboro", address: "735 SE Baseline St, Hillsboro, OR 97123", hours: "Daily 8 AM – 10 PM", website: "https://www.walgreens.com/" },
    { name: "CVS — Hillsboro", address: "1955 SE TV Hwy, Hillsboro, OR 97123", hours: "Daily 7 AM – 10 PM", website: "https://www.cvs.com/" },
    { name: "FedEx Office — Hillsboro", address: "2045 NW 185th Ave, Hillsboro, OR 97124", hours: "Mon–Fri 7 AM – 10 PM, Sat–Sun 8 AM – 8 PM", website: "https://www.fedex.com/" },
    { name: "The UPS Store — Hillsboro", address: "1925 NE Cornell Rd, Hillsboro, OR 97124", hours: "Mon–Fri 8 AM – 7 PM", website: "https://www.theupsstore.com/" },
    { name: "Walmart — Hillsboro", address: "3000 NE 14th Ave, Hillsboro, OR 97124", hours: "Daily 7 AM – 11 PM", website: "https://www.walmart.com/" },
    { name: "Walgreens — Beaverton", address: "14425 SW Allen Blvd, Beaverton, OR 97005", hours: "Daily 8 AM – 10 PM", website: "https://www.walgreens.com/" },
    { name: "CVS — Beaverton", address: "4705 SW Watson Ave, Beaverton, OR 97005", hours: "Daily 7 AM – 10 PM", website: "https://www.cvs.com/" },
    { name: "FedEx Office — Beaverton", address: "1590 NW 185th Ave, Beaverton, OR 97006", hours: "Mon–Fri 7 AM – 10 PM", website: "https://www.fedex.com/" },
    { name: "Walmart — Beaverton", address: "11425 SW Beaverton Hillsdale Hwy, Beaverton, OR 97005", hours: "Daily 7 AM – 11 PM", website: "https://www.walmart.com/" },
    { name: "Walgreens — Tigard", address: "12345 SW Main St, Tigard, OR 97223", hours: "Daily 8 AM – 10 PM", website: "https://www.walgreens.com/" },
  ],
  dmvLocations: [
    {
      name: "Hillsboro DMV Office",
      address: "2210 E Main St, Hillsboro, OR 97123",
      hours: "Mon–Fri 8:30 AM – 5:00 PM",
      note: "Washington County DMV office. Driver licenses, REAL ID, ID cards. Appointment recommended.",
      featured: true,
    },
    {
      name: "Beaverton DMV Office",
      address: "14075 SW Barrows Rd, Beaverton, OR 97007",
      hours: "Mon–Fri 8:30 AM – 5:00 PM",
      note: "Washington County option for Beaverton and eastern Hillsboro residents.",
      featured: false,
    },
    {
      name: "Portland DMV Office — Swan Island",
      address: "1905 N Hayden Island Dr, Portland, OR 97217",
      hours: "Mon–Fri 8:30 AM – 5:00 PM",
      note: "Portland option for east Hillsboro metro residents.",
      featured: false,
    },
  ],
  airports: [
    {
      code: "PDX",
      name: "Portland International Airport",
      distance: "Primary international airport — about 25 miles east",
      address: "7000 NE Airport Way, Portland, OR 97218",
      note: "PDX offers direct international flights to Amsterdam, London, Reykjavik, Tokyo, Vancouver, and more. The busiest travel seasons are May–August and December–January.",
      flightUrl: "https://www.flypdx.com/",
      flightLabel: "PDX Airport Website",
      featured: true,
    },
    {
      code: "HIO",
      name: "Hillsboro Airport",
      distance: "General aviation — in Hillsboro",
      address: "3355 NE Cornell Rd, Hillsboro, OR 97124",
      note: "Hillsboro Airport is general aviation only — no commercial flights. International travelers use PDX.",
      flightUrl: "https://www.portofportland.com/hio",
      flightLabel: "HIO Airport Info",
      featured: false,
    },
    {
      code: "SEA",
      name: "Seattle-Tacoma International Airport",
      distance: "Alternative hub — about 175 miles north",
      address: "17801 International Blvd, SeaTac, WA 98158",
      note: "Some Hillsboro travelers use SEA for additional flight options. Passport required for all international departures.",
      flightUrl: "https://www.portseattle.org/sea-tac",
      flightLabel: "SEA Airport Website",
      featured: false,
    },
  ],
  services: [
    {
      icon: "ri-time-line",
      title: "Emergency Passport",
      description: "Flying from PDX in 24–72 hours? Our emergency courier service is designed for urgent, last-minute travel from Hillsboro and Washington County.",
      bullets: ["As fast as 24 hours", "Reserved agency submission slots", "Live case tracking"],
      badge: "Same-Day Available",
      link: "https://fastpassportcenter.com/checkout/?passport=emergency-passport",
    },
    {
      icon: "ri-refresh-line",
      title: "Passport Renewal",
      description: "Already have a U.S. passport? We help Hillsboro and Silicon Forest workers renew fast — perfect for business travel and family vacations.",
      bullets: ["Eligible for expedited processing", "Ship from any FedEx or UPS in Hillsboro", "Professional document review"],
      badge: "Most Common",
      link: "https://fastpassportcenter.com/checkout/?passport=passport-renewal",
    },
    {
      icon: "ri-search-eye-line",
      title: "Lost Passport Replacement",
      description: "Lost your passport before a trip? We guide Hillsboro travelers through Form DS-64 and the replacement process — urgent timelines available.",
      bullets: ["DS-64 form guidance included", "Replacement processing", "Urgent timelines available"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=lost-stolen-passport",
    },
    {
      icon: "ri-parent-line",
      title: "Child Passport",
      description: "Child passport expedited service for Hillsboro families — minors under 16 require in-person acceptance and parental consent. We provide clear instructions and checklists.",
      bullets: ["Both parents must typically consent", "Clear checklist provided", "Expedited options after acceptance step"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=child-passport",
    },
    {
      icon: "ri-file-add-line",
      title: "New Passport",
      description: "First-time passport application assistance for Hillsboro residents — we guide you through the acceptance clerk process and handle expedited processing.",
      bullets: ["Step-by-step checklist", "Acceptance clerk guidance", "Expedited after clerk visit"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=new-passport",
    },
    {
      icon: "ri-truck-line",
      title: "Passport Courier Service",
      description: "Fast Passport Center is a registered U.S. Department of State courier — we submit through reserved agency channels, not public lines. Same-day passport help for Hillsboro travelers.",
      bullets: ["State Dept. registered courier", "Reserved daily submission slots", "Not affected by government shutdowns"],
      badge: "Registered Courier",
      link: "https://fastpassportcenter.com/checkout/",
    },
    {
      icon: "ri-edit-line",
      title: "Name Change & Other Services",
      description: "Passport name changes after marriage or divorce, damaged passport replacement, second passports for frequent travelers — all handled with the same expedited courier access.",
      bullets: ["Name change after marriage/divorce", "Damaged passport replacement", "Second passport for frequent travel"],
      badge: null,
      link: "https://fastpassportcenter.com/checkout/?passport=name-change",
    },
  ],
  servicesSchema: [
    { name: "Emergency Passport", description: "Urgent passport processing for Hillsboro, Oregon travelers with immediate departure needs, as fast as 24 hours." },
    { name: "Expedited Passport", description: "Expedited passport processing for Hillsboro residents needing passports faster than standard government mail timelines." },
    { name: "Passport Renewal", description: "Fast passport renewal for Hillsboro, OR residents with a passport issued within the last 15 years at age 16 or older." },
    { name: "Lost Passport Replacement", description: "Emergency passport replacement service for Hillsboro travelers with lost or stolen passports." },
    { name: "Child Passport", description: "Expedited child passport services for Hillsboro families with minors under 16." },
    { name: "Passport Courier Service", description: "Registered U.S. Department of State courier passport submission service serving Hillsboro, Oregon." },
  ],
  mistakes: [
    { icon: "ri-time-line", title: "Waiting Too Long to Apply", description: "Hillsboro tech workers and families often assume 6–8 weeks is safe — it's not. Government processing has stretched to 10–14+ weeks during peak travel season. Apply as soon as you book your trip, especially for summer and holiday travel from PDX." },
    { icon: "ri-camera-off-line", title: "Wrong Passport Photo", description: "Photos from drugstores and photo booths often get rejected for lighting, background, or expression issues. We provide exact specs and can catch these issues before your documents are submitted." },
    { icon: "ri-file-damage-line", title: "Incomplete or Incorrect Forms", description: "One wrong date, one missing signature — your application gets sent back and you lose weeks. Our checklist catches errors before submission, critical for last-minute passport renewal in Hillsboro." },
    { icon: "ri-pen-nib-line", title: "Wrong Birth Certificate Type", description: "Not all birth certificates are accepted. Some require a long-form certified copy with a raised seal. Fast Passport Center tells you exactly what you need based on your situation." },
    { icon: "ri-calendar-close-line", title: "Assuming the Post Office is Fast Enough", description: "Standard USPS passport processing out of Hillsboro runs 6–13 weeks. If your trip to Europe, Asia, or Canada is in under 10 weeks, standard processing is a gamble. Use our courier service instead." },
    { icon: "ri-map-pin-time-line", title: "Name Mismatch Across Documents", description: "Your passport name must match your airline ticket exactly — especially for international flights out of PDX. Middle names, hyphens, and suffixes cause more rejections than you'd expect." },
  ],
  steps: [
    { number: "01", icon: "ri-computer-line", title: "Start Your Order Online", description: "Choose your processing speed based on your Hillsboro travel date. Complete your secure order online — takes just a few minutes." },
    { number: "02", icon: "ri-file-list-3-line", title: "Receive Your Personalized Checklist", description: "We confirm your details and send you a personalized document checklist — exactly what you need, nothing more." },
    { number: "03", icon: "ri-send-plane-line", title: "Ship Documents Overnight from Hillsboro", description: "Drop off at any FedEx or UPS in the Hillsboro or Beaverton area — most locations are open evenings. No office visit to our facility required." },
    { number: "04", icon: "ri-building-2-line", title: "We Submit Through Reserved Access", description: "We submit your application through our reserved passport agency slots — bypassing the public appointment system entirely." },
    { number: "05", icon: "ri-passport-line", title: "Your Passport is Completed", description: "Your passport is completed within the timeframe you selected and shipped back to you. No guessing, no hoping." },
  ],
  processingOptions: [
    {
      speed: "2–9",
      unit: "Business Days",
      label: "Fast Passport Center",
      tag: "Most Popular",
      tagColor: "bg-[#F6C344] text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Predictable turnaround",
        "Ideal for upcoming trips",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: true,
    },
    {
      speed: "3–5",
      unit: "Weeks",
      label: "Fast Passport Center",
      tag: "Standard Expedited",
      tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
      features: [
        "Registered U.S. Department of State Courier",
        "Reserved agency submission",
        "Faster than self-service",
        "Good for planned travel",
        "Document review included",
        "Dedicated agent assigned to your case",
        "Daily status updates — never left guessing",
        "Not affected by government shutdowns",
      ],
      highlight: false,
      smartSaver: true,
    },
    {
      speed: "1–2",
      unit: "Months",
      label: "Self-Service (Post Office)",
      tag: "Slowest",
      tagColor: "bg-gray-100 text-gray-400",
      features: [
        "No courier access — standard mail only",
        "Workload & wait times shift with shutdowns and budget fights",
        "In-person clerk appointment required",
        "No document review — errors cause rejection",
        "No dedicated agent — you are on your own",
        "Updates only by physical mail letter",
        "No phone or email contact for your case",
        "Can't upgrade speed after submission",
        "Not suitable if travel is within 10 weeks",
      ],
      highlight: false,
      muted: true,
    },
    {
      speed: "24",
      unit: "Hours*",
      label: "Regional Agency Processing",
      tag: "Emergency Only",
      tagColor: "bg-gray-100 text-gray-500",
      features: [
        "Appointment required — no walk-ins allowed",
        "Life-or-death emergencies only",
        "Bereavement or medical crisis",
        "Expect to wait all day or return next day",
      ],
      highlight: false,
      emergency: true,
    },
  ],
  comparisonRows: [
    { feature: "Appointment Required", agency: "Yes — limited slots, often weeks out in Seattle", fpc: "No appointment needed to start" },
    { feature: "In-Person Visit", agency: "Must drive to Seattle (3 hours each way)", fpc: "Ship documents overnight from Hillsboro" },
    { feature: "Processing Speed", agency: "Urgent travel only — strict eligibility", fpc: "As fast as 24 hours — multiple speed options" },
    { feature: "Document Review", agency: "None — errors cause rejection", fpc: "Professional review included" },
    { feature: "Courier Access", agency: "Not available to the public", fpc: "Reserved daily submission slots" },
    { feature: "Predictability", agency: "Appointments can be cancelled or unavailable", fpc: "Predictable processing based on option selected" },
    { feature: "Government Shutdowns", agency: "Operations may be impacted", fpc: "Not affected by government shutdowns" },
  ],
  stickyNavLinks: [
    { label: "Processing Options", href: "#processing-options" },
    { label: "Services", href: "#services" },
    { label: "Service Area", href: "#service-area" },
    { label: "Acceptance Locations", href: "#acceptance-facilities" },
    { label: "vs. Regional Agency", href: "#comparison" },
    { label: "FAQ", href: "#faq" },
    { label: "Local Resources", href: "#local-resources" },
  ],
  internalLinks: [
    { name: "Expedited passport services in Portland", route: "/cities/portland" },
    { name: "Fast passport renewal in Beaverton", route: "/cities/beaverton" },
    { name: "Emergency passport help near Salem", route: "/cities/salem" },
    { name: "Rush passport service in Tigard", route: "#" },
    { name: "Fast passport renewal for Washington County travelers", route: "/states/oregon" },
  ],
  fpcOfficeAddress: "5608 17th Avenue NW, Seattle, WA 98107",
  fpcOfficeNote: "After signing up online, we send your personalized checklist and shipping instructions. Ship your documents overnight from any FedEx or UPS location in Hillsboro or Beaverton — most are open evenings. No office visit to our facility required for most services.",
  fpcOfficeDistance: "Serving Hillsboro and all of Washington County remotely",
  serviceAreaIntro: "Whether you are in downtown Hillsboro, near the Intel campus, Beaverton, Forest Grove, Cornelius, or anywhere in Washington County, Fast Passport Center makes expedited passport processing simple — start online, ship overnight, and we handle the rest.",
  nearbyCitiesIntro: "We serve all Hillsboro-area zip codes. Anywhere in Washington County or the western Portland metro — ship overnight and your documents are at our processing center the next morning.",
  howItWorksIntro: "From start to finish, we make getting an expedited passport in Hillsboro as simple as possible. Most Hillsboro clients never visit an office.",
  mistakesIntro: "These mistakes cause the most delays and rejections for Hillsboro travelers. Fast Passport Center reviews your documents before submission to catch these issues before they become problems.",
  testimonialsIntro: "Real reviews from Hillsboro, Beaverton, and Washington County travelers who needed their passports fast and trusted Fast Passport Center.",
  faqIntro: "The most common questions Hillsboro and Silicon Forest travelers ask about emergency and expedited passport services.",
  statePageRoute: "/states/oregon",
  statePageName: "Oregon",
  dmvWebsite: "https://www.oregon.gov/odot/dmv",
  dmvLabel: "Oregon DMV — Official Website",
};